import React from 'react';
import Embark from "./LogoOfCarriers/Embark.png"
import AssuranceAmerica from "./LogoOfCarriers/AssuranceAmerica.png"
import Responsive from "./LogoOfCarriers/Responsive Auto Insurance Company.png"
import NationalGeneral from "./LogoOfCarriers/NationalGeneral.png";
import PearlHolding from "./LogoOfCarriers/Pearl Holding.jpg";
import UAIC from "./LogoOfCarriers/UAIC.png";
import Amwins from "./LogoOfCarriers/Amwins.png"
import BristolWest from "./LogoOfCarriers/bristol_west.png"
import KemperAuto from "./LogoOfCarriers/KemperAuto.jpg"
import { Box } from '@mui/material';

export const companyLogos = {
    "Responsive": Responsive,
    "Pearl Holding": PearlHolding,
    "National General": NationalGeneral,
    "Embark": Embark,
    "United Auto": UAIC,
    "United Auto Premier": UAIC,
    "Assurance America Economy": AssuranceAmerica,
    "Assurance America Elite": AssuranceAmerica,
    "Amwins":Amwins,
    "Bristol West":BristolWest,
    "Kemper":KemperAuto,
  };

function getCompanyLogo(companyName) {
    if (!companyName) return null;

  const name = companyName.toLowerCase();
  let logoPath = "";

  if (name.includes('embark')) {
    logoPath = Embark;
  } else if (name.includes('national')) {
    logoPath = NationalGeneral;
  } else if (name.includes('pearl')) {
    logoPath = PearlHolding;
  } else if (name.includes('responsive')) {
    logoPath = Responsive;
  } else if (name.includes('assurance america')) {
    logoPath = AssuranceAmerica;
  } else if (name.includes('united')) {
    logoPath = UAIC;
  } else if (name.includes('bristol')) {
    logoPath = BristolWest;
  }
  else if (name.includes('amwins')) {
    logoPath = Amwins;
  }
   else if (name.includes('kemper')) {
    logoPath = KemperAuto;
  }
   else {
    // Default or placeholder image if no match
    return null;
  }
  return (
     <Box sx={{ width: '100px', height: '30px', display: 'flex', alignItems: 'center' }}>
         <img
           src={logoPath}
           alt={companyName}
           style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
         />
       </Box>
  )
}

export default getCompanyLogo
